import { useState, useRef, useCallback } from "react";
import { useTextPersistence } from "qwanyx";
import { formatDateForDisplay, parseDateFromDisplay } from '../utils/dateUtils';

export const useInputLogic = ({ type, value, qwantumId, onSave, enabled, allowEditing, setProp }) => {
  const { text, handleBlur: persistenceBlur } = useTextPersistence(qwantumId, onSave);
  const [prevValue, setPrevValue] = useState(value || text || "");
  const inputRef = useRef(null);

  const getInitialValue = useCallback(() => {
    const currentValue = value || text || "";
    if (type === 'date') {
      return formatDateForDisplay(currentValue);
    }
    return currentValue;
  }, [value, text, type]);

  const handleBlur = useCallback((e) => {
    const newValue = e.target.value;

    if (newValue !== prevValue) {
      if (onSave) {
        onSave(newValue);
      }
      setPrevValue(newValue);
      
      if (enabled || allowEditing) {
        setProp(props => props.value = newValue);
      }
    }

    if (qwantumId) {
      persistenceBlur(e);
    }
  }, [prevValue, onSave, enabled, allowEditing, setProp, qwantumId, persistenceBlur]);

  const handleDateBlur = useCallback((e) => {
    const displayValue = e.target.value;
    const isoValue = parseDateFromDisplay(displayValue);
    
    const syntheticEvent = {
      target: { value: isoValue }
    };
    handleBlur(syntheticEvent);
  }, [handleBlur]);

  const handleDateFocus = useCallback((e) => {
    const input = e.target;
    const currentValue = parseDateFromDisplay(input.value);
    
    input.type = 'date';
    input.value = currentValue;
    
    setTimeout(() => {
      input.showPicker?.();
    }, 0);
    
    const handleDateSelect = (event) => {
      const selectedDate = event.target.value;
      if (selectedDate) {
        input.type = 'text';
        input.value = formatDateForDisplay(selectedDate);
        input.removeEventListener('change', handleDateSelect);
      }
    };
    
    const handleDateBlurInternal = () => {
      input.type = 'text';
      input.value = formatDateForDisplay(input.value);
      input.removeEventListener('change', handleDateSelect);
      input.removeEventListener('blur', handleDateBlurInternal);
    };
    
    input.addEventListener('change', handleDateSelect);
    input.addEventListener('blur', handleDateBlurInternal);
  }, []);

  return {
    inputRef,
    getInitialValue,
    handleBlur,
    handleDateBlur,
    handleDateFocus
  };
};